
import { defineComponent } from "vue";

export default defineComponent({
  name: "LButtomMenu",
  props: { isToggle: Boolean },
  methods: {
    toggleOpen() {
      this.$emit("show:menu");
    },
    animateMenu() {
      const menu_burger = document.getElementById("menu_burger");
      if (menu_burger) {
        menu_burger.classList.toggle("opened");
        if (menu_burger.classList) {
          menu_burger.setAttribute(
            "aria-expanded",
            menu_burger.classList.contains("opened").toString()
          );
        }
      }
    },
  },
  watch: {
    isToggle() {
      this.animateMenu();
    },
  },
});
